import {type RefObject, useEffect, useRef} from 'react';

const PULL_THRESHOLD_PX = 60;

const usePullToCollapse = (scrollRef: RefObject<HTMLElement | null>, onCollapse: () => void) => {
    const onCollapseRef = useRef(onCollapse);
    onCollapseRef.current = onCollapse;

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        let anchorY = 0;
        let fired = false;

        const handleTouchStart = (e: TouchEvent) => {
            anchorY = e.touches[0]?.clientY ?? 0;
            fired = false;
        };

        const handleTouchMove = (e: TouchEvent) => {
            const currentY = e.touches[0]?.clientY;
            if (currentY === undefined) return;

            if (el.scrollTop > 0) {
                anchorY = currentY;
                return;
            }

            if (!fired && currentY - anchorY > PULL_THRESHOLD_PX) {
                fired = true;
                onCollapseRef.current();
            }
        };

        const handleTouchEnd = () => {
            fired = false;
        };

        el.addEventListener('touchstart', handleTouchStart, {passive: true});
        el.addEventListener('touchmove', handleTouchMove, {passive: true});
        el.addEventListener('touchend', handleTouchEnd, {passive: true});

        return () => {
            el.removeEventListener('touchstart', handleTouchStart);
            el.removeEventListener('touchmove', handleTouchMove);
            el.removeEventListener('touchend', handleTouchEnd);
        };
    }, [scrollRef]);
};

export default usePullToCollapse;
